import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { environment } from "../environments/environment";
import { Position } from "./app";
// import { VexSidebarComponent } from "@vex/components/vex-sidebar/vex-sidebar.component";
 
 

@Injectable({ providedIn: 'root' })
export class AppService {
    static readonly HEADER_CONSULTA_POST_NAME: string = 'consulta-post';
    static readonly HEADER_CONSULTA_POST: HttpHeaders = new HttpHeaders({
        'consulta-post': 'true'
    });

    carregando = signal(false);
    // configPanel!: VexSidebarComponent;

    rastreavel = signal(false);
    posicao: Position | null = null;

    constructor(
        private readonly http: HttpClient
    ) {}

    iniciarCarregamento() {
        this.carregando.set(true);
    }
    
    concluirCarregamento() {
        this.carregando.set(false);
    }

    setPosicao(posicao: Position | null): void {
        this.posicao = posicao;        
    }

    getPosicao(): Position | null {
        return this.posicao;
    }

    getDeviceId(): string {
        const key = 'nexus_device_id';
        let id = localStorage.getItem(key);
        if (!id) {
            id = crypto.randomUUID();
            localStorage.setItem(key, id);
        }
        return id;
    }
    
    salvaSessao(latitude: string, longitude: string, deviceId: string, plataforma: string) {
        return this.http.post(`${environment.apiNexus}/v1/sessao`, 
            {
                latitude,
                longitude,
                deviceId,
                plataforma,
            }
        );
    }

}